﻿import * as types from '../actions/ShowcaseOrderActionTypes';
import InitialState from './InitialState';


export default function showcaseOrderReducer(
    state: any = InitialState.showcaseOrder,
    action: { type: string; result: any }
) {

    switch (action.type) {
        
        case types.GET_SHOWCASE_ORDER_SUCCESS:
            return action.result.showcaseOrder
            
        default:
            
            return state;
    }
}
